import { requestOptions, HttpMethod } from "../../../utils/api/request-options";
import { handleResponse, handleResponseNoContent } from "../../../utils/api/response-handler";
import { Stream } from "../model/stream";

export function getStreams(cohortId: number): Promise<Stream[]> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/cohort/${cohortId}/stream/list`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<Stream[]>(response);
        });
}

export function getStream(cohortId: number, streamId: number): Promise<Stream> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/cohort/${cohortId}/stream/${streamId}`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<Stream>(response);
        });
}

export function addStream(cohortId: number, stream: Stream): Promise<Stream> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/cohort/${cohortId}/stream`, requestOptions(HttpMethod.POST, stream))
        .then(response => {
            return handleResponse<Stream>(response);
        });
}

export function updateStream(cohortId: number, stream: Stream): Promise<Stream> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/cohort/${cohortId}/stream`, requestOptions(HttpMethod.PUT, stream))
        .then(response => {
            return handleResponse<Stream>(response);
        });
}

export function deleteStream(cohortId: number, streamId: number): Promise<void> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/cohort/${cohortId}/stream/${streamId}`, requestOptions(HttpMethod.DELETE))
        .then(response => {
            return handleResponseNoContent(response);
        });
}
